import axios from 'axios';
import { handleAuthFailure } from './api/auth-fallback'



export const courseUrl = 'https://course.3class.cc/'
export const bannerUrl = 'https://course.3class.cc/api/banner/v1/' 

export const codeUrl = 'https://judge.3class.cc'
export const chapterURL ='https://course.3class.cc/api/chapter/v1/'
export const judgeUrl = 'https://judge.3class.cc/api/judge/v1/' 
export const pkaUrl = 'https://judge.3class.cc/api/pka_score/v1/' 
export const toolUrl = 'https://course.3class.cc/api/tool/v1/' 
export const categoryUrl = 'https://course.3class.cc/api/category/v1/' 
export const userUrl = 'https://user.3class.cc/api/user/v1' 
export const wxUrl = 'https://user.3class.cc/wx/login/' 
export const loginUrl ='https://judge.3class.cc/api/user/v1/login'
const service = axios.create({
  baseURL: "http://127.0.0.1:8080/",
  timeout: 50000,
  withCredentials: false,
  transformRequest: [(data, headers) => {
    headers["X-Requested-With"] ='XMLHttpRequest'
    headers["Content-Type"] = 'application/json; charset=UTF-8'
    // if(localStorage.getItem("access_token")){
      headers["Authorization"] = 'Bearer sk-1hvc2fcb4b6fa98844d9c43331d74acef8792676079lXfI8' 

    headers['token']= localStorage.getItem('token')
    return JSON.stringify(data)
    
  }]
});

service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// service.interceptors.response.use(
//   response => {
//     if(response.data.code != '0000') {
//       Message({message: response.data.data,type: "error"})
//       return
//     }
//     return Promise.resolve(response.data);

//   },
//   error => {
//     return Promise.reject(error)
//   }
// );


// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    // 原来这里是一串 localStorage.clear('id') + location.reload()。
    // clear() 会忽略参数清空整个 localStorage，而 reload 解决不了"没登录"，
    // 未登录访问时会变成无限刷新。改为只清认证键、不刷新，业务码交回页面。
    handleAuthFailure(res)
    return res
  },
  error => {
        return Promise.reject(error)
  }
)
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js